import React, { Component } from "react";
import Card from "Utils/Cards/Card";
import { ConsultaCierreMensual } from "./components/ConsultaCierreMensual";
import "../../../components/Existencia/styles/Existencia.css";

class CreacionCierreMensual extends Component {
    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="inventario_activo"
                    titulo="CIERRE MENSUAL INVENTARIO"
                    subtitulo=""
                    noBorder
                >
                    <ConsultaCierreMensual onRegresar={this.regresar} />
                </Card>
            </div>
        );
    }
}

export default CreacionCierreMensual;
